import DocViewer from '@cyntler/react-doc-viewer';
import { styled } from '@mui/material';

const DocumentPreviewer = styled(DocViewer)(({ theme }) => ({
  '#pdf-controls, #header-bar': {
    display: 'none',
  },
  '#image-renderer': {
    backgroundImage: 'none',
    backgroundColor: theme.palette.surfaceContainerLow.main,
    borderRadius: 14,
  },
  borderRadius: 14,
  background: `${theme.palette.surfaceContainerLow.main} !important`,
})) as unknown as typeof DocViewer;

export default DocumentPreviewer;
